import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './features/sm/styles/tokens.css'
import './features/sm/styles/phone.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
